<template>
  <div class="app-deprecation-notice">
    <div class="app-deprecation-notice-wrapper">
      <svg xmlns="http://www.w3.org/2000/svg" width="43" height="42" viewBox="0 0 43 42" fill="none">
        <path
          d="M18.5075 6.75487L3.68501 31.4999C3.3794 32.0291 3.2177 32.6291 3.21599 33.2403C3.21428 33.8514 3.37261 34.4523 3.67525 34.9833C3.97789 35.5142 4.41428 35.9567 4.94099 36.2666C5.46771 36.5765 6.0664 36.7432 6.67751 36.7499H36.3225C36.9336 36.7432 37.5323 36.5765 38.059 36.2666C38.5857 35.9567 39.0221 35.5142 39.3248 34.9833C39.6274 34.4523 39.7857 33.8514 39.784 33.2403C39.7823 32.6291 39.6206 32.0291 39.315 31.4999L24.4925 6.75487C24.1805 6.24056 23.7413 5.81533 23.2171 5.52022C22.6929 5.2251 22.1015 5.07007 21.5 5.07007C20.8985 5.07007 20.3071 5.2251 19.7829 5.52022C19.2587 5.81533 18.8195 6.24056 18.5075 6.75487V6.75487Z"
          fill="#434343"
        />
        <path d="M21.5 15.75V22.75" stroke="white" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M21.5 29.75H21.5175" stroke="white" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <h1>닥플 모바일 앱 서비스가 일시 중지되었습니다</h1>
      <p>
        더 나은 서비스로 돌아오기 위해 전면 리뉴얼을 준비하고 있습니다. 새로운 모습으로 곧 찾아뵙겠습니다. 모바일 웹에서는 지금도 서비스를 이용하실 수있습니다.
      </p>
      <div class="link-container">
        <div>닥플 모바일 웹 주소</div>
        <div class="link-container-item">
          <span>https://docple.docple-plus.com</span>
          <button type="button" @click="handleCopy">
            복사
          </button>
        </div>
      </div>
      <p>
        위 주소를 브라우저에 입력하여 접속해주세요. <br />
        이용에 불편을 드려 죄송합니다.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppDeprecationNotice',
  mounted() {
    const pcBgColor = document.querySelector('.pc-bg-color');
    if (pcBgColor) {
      pcBgColor.classList.add('responsive');
    }
  },
  beforeDestroy() {
    const pcBgColor = document.querySelector('.pc-bg-color');
    if (pcBgColor) {
      pcBgColor.classList.remove('responsive');
    }
  },
  methods: {
    handleCopy() {
      navigator.clipboard.writeText('https://docple.docple-plus.com');
      alert('URL이 복사되었습니다.');
    },
  },
};
</script>

<style lang="scss" scoped>
.app-deprecation-notice {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  background-color: #fff;

  .app-deprecation-notice-wrapper {
    max-width: 335px;
    display: flex;
    flex-direction: column;

    button {
      background: none;
      border: none;
      cursor: pointer;
      color: #52565d;
      font-size: 15px;
      font-style: normal;
      line-height: 23px; /* 153.333% */
      margin-left: auto;
    }
  }

  svg {
    margin: 0 auto;
  }

  h1 {
    color: #23272b;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 26px; /* 144.444% */
    margin: 8px 0;
  }

  p {
    color: #52565d;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Pretendard;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 150% */
  }

  .link-container {
    display: flex;
    flex-direction: column;
    padding: 16px 12px;
    justify-content: center;
    gap: 10px;
    align-self: stretch;
    border-radius: 8px;
    background: #f7f8f9;

    color: #52565d;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Pretendard;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: 23px; /* 153.333% */
    margin: 16px 0;

    span {
      color: #089feb;
    }
  }

  .link-container-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
